import { FETCH_STITCHING_INWARD_DETAILS_EDIT_QTY_REQUEST } from '../../StitchingInward/stitchingInwardDetails/stitchingInwardDetails.actionsType';
import {
    CREATE_CUTTING_DC_INWARD_DETAILS_REQUEST,
    CREATE_CUTTING_DC_INWARD_DETAILS_SUCCESS,
    CREATE_CUTTING_DC_INWARD_DETAILS_FAILURE,
    DELETE_CUTTING_DC_INWARD_DETAILS_REQUEST,
    DELETE_CUTTING_DC_INWARD_DETAILS_SUCCESS,
    DELETE_CUTTING_DC_INWARD_DETAILS_FAILURE,
    FETCH_SINGLE_CUTTING_DC_INWARD_DETAILS_REQUEST,
    FETCH_SINGLE_CUTTING_DC_INWARD_DETAILS_SUCCESS,
    FETCH_SINGLE_CUTTING_DC_INWARD_DETAILS_FAILURE,
    FETCH_CUTTING_DC_INWARD_DETAILS_REQUEST,
    FETCH_CUTTING_DC_INWARD_DETAILS_SUCCESS,
    FETCH_CUTTING_DC_INWARD_DETAILS_FAILURE,
    UPDATE_CUTTING_DC_INWARD_DETAILS_REQUEST,
    UPDATE_CUTTING_DC_INWARD_DETAILS_SUCCESS,
    UPDATE_CUTTING_DC_INWARD_DETAILS_FAILURE,
    RESET_CUTTING_DC_INWARD_DETAILS_INFO,
    CREATE_CUTTING_DC_INWARD_DETAILS_FORM,
    UPDATE_CUTTING_DC_INWARD_DETAILS_FORM,
    FETCH_CUTTING_DC_INWARD_DETAILS_WITHOUT_ID_SUCCESS,
    FETCH_CUTTING_INWARD_DETAILS_EDIT_QTY_FAILURE,
    FETCH_CUTTING_INWARD_DETAILS_EDIT_QTY_SUCCESS,
    SET_EDIT_QUANTITY_GRID_DATA_WITHOUT_CUTTING_INWARD_ID,
    RESET_EDIT_QUANTITY_GRID_DATA_WITHOUT_CUTTING_INWARD_ID,
    RESET_EDIT_QUANTITY_GRID_DATA_WITHOUT_CUTTING_INWARD_ID_V2,
    FETCH_CUTTING_INWARD_DETAILS_ID_FALIURE,
    FETCH_CUTTING_INWARD_DETAILS_ID_SUCCESS,
    FETCH_CUTTING_INWARD_DETAILS_ID_REQUEST,
    FETCH_CUTTING_INWARD_DETAILS_PART_COM_SUCCESS,
    FETCH_CUTTING_INWARD_DETAILS_PART_COM_REQUEST,
    FETCH_CUTTING_INWARD_DETAILS_PART_COM_FALIURE,
    FETCH_CUTTING_INWARD_DETAILS_UNIQUE_ID_FALIURE,
    FETCH_CUTTING_INWARD_DETAILS_UNIQUE_ID_SUCCESS,
    FETCH_CUTTING_INWARD_DETAILS_UNIQUE_ID_REQUEST,
    FETCH_POST_BUNDLE_POST_REQUEST,
    FETCH_POST_BUNDLE_POST_FALIURE,
    FETCH_BUNDLE_INPUT_SUCCESS,
    FETCH_BUNDLE_INPUT_FALIURE,
    FETCH_BUNDLE_INPUT_REQUEST,
    FETCH_POST_BUNDLE_POST_SUCCESS,
    FETCH_DETAIL_DC_NO_SUCCESS,
    FETCH_CUTTING_DC_INWARD_BUNDLE_SUCCESS,
    FETCH_CUTTING_DC_INWARD_BUNDLE_PROGRAM_WISE_REQUEST,
    FETCH_CUTTING_DC_INWARD_BUNDLE_PROGRAM_WISE_FAILURE,
    FETCH_CUTTING_DC_INWARD_BUNDLE_PROGRAM_WISE_SUCCESS
} from './cuttingDcInwardDetails.actionsType';

export const CUTTING_DC_INWARD_DETAILS = 'cuttingDcInwardDetails';

let initialState = {
    loading: false,
    cuttingDcInwardDetails: [],
    editGridData: [],
    cuttingDcInwardDetailsWithoutId: [],
    cuttingDcInwardDetailsForm: {
        fldItemRate: 0,
        fldQuantity: 0,
        fldGrossValue: 0,
        fldDiscountValue: 0,
        fldIGSTValue: 0,
        fldSGSTValue: 0,
        fldCGSTValue: 0,
        fldCGSTPercentage: 0,
        fldIGSTPercentage: 0,
        fldSGSTPercentage: 0,
        fldDiscountPercentage: 0
    },
    selectedState: {},
    errorMessage: '',
    unquieIdData: [],
    updateKey: 0,
};

export let cuttingDcInwardDetailsReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;
    if (type === 'FETCH_CUTTING_INWARD_DETAILS_ID_SUCCESS') {
        localStorage.setItem('getIDPayload', JSON.stringify(updatePayload));
    }

    switch (type) {
        case FETCH_CUTTING_DC_INWARD_DETAILS_REQUEST:
        case CREATE_CUTTING_DC_INWARD_DETAILS_REQUEST:
        case UPDATE_CUTTING_DC_INWARD_DETAILS_REQUEST:
        case FETCH_SINGLE_CUTTING_DC_INWARD_DETAILS_REQUEST:
        case FETCH_STITCHING_INWARD_DETAILS_EDIT_QTY_REQUEST:
        case DELETE_CUTTING_DC_INWARD_DETAILS_REQUEST:
        case FETCH_CUTTING_INWARD_DETAILS_ID_REQUEST:
        case FETCH_CUTTING_INWARD_DETAILS_PART_COM_REQUEST:
        case FETCH_CUTTING_INWARD_DETAILS_UNIQUE_ID_REQUEST:
        case FETCH_POST_BUNDLE_POST_REQUEST:
        case FETCH_BUNDLE_INPUT_REQUEST:
        case FETCH_CUTTING_DC_INWARD_BUNDLE_PROGRAM_WISE_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_POST_BUNDLE_POST_SUCCESS:
            return {
                ...state,
                loading: false,
                updateKey: ((prev) => prev + 1)
            }
        case FETCH_CUTTING_DC_INWARD_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                cuttingDcInwardDetails: updatePayload
            };
        case FETCH_CUTTING_DC_INWARD_DETAILS_WITHOUT_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                cuttingDcInwardDetailsWithoutId: updatePayload
            };
        case CREATE_CUTTING_DC_INWARD_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                cuttingDcInwardDetailsForm: {
                    fldItemRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0
                }
            };
        case FETCH_CUTTING_INWARD_DETAILS_EDIT_QTY_SUCCESS:
            return {
                ...state,
                loading: false,
                editGridData: (updatePayload?.CUD && updatePayload?.CUD.map((x) => ({ ...x, fldInwardQty: x?.PendingQty, fldFKDCDetailNo: x.FldId }))) || []
            };

        case FETCH_BUNDLE_INPUT_SUCCESS:
            return {
                ...state,
                loading: false,
                bundleInputValues: updatePayload
            }
        case FETCH_CUTTING_INWARD_DETAILS_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                getIDPayload: updatePayload,
                loadRefresh: updatePayload?.CUD?.map((x, i) => i),
                getSearchedItem: updatePayload?.CUD

            }
        case SET_EDIT_QUANTITY_GRID_DATA_WITHOUT_CUTTING_INWARD_ID:
            return {
                ...state,
                loading: false,
                editGridData: payload,
                getIDPayload: {
                    CUD: payload
                }
            };
        case FETCH_CUTTING_DC_INWARD_BUNDLE_SUCCESS:
            return {
                ...state,
                loading: false,
                cuttingBundleLists: updatePayload
            }
        case FETCH_CUTTING_DC_INWARD_BUNDLE_PROGRAM_WISE_SUCCESS:
            return {
                ...state,
                loading: false,
                cuttingBundleProgramWiseLists: updatePayload || []
            }
        case RESET_EDIT_QUANTITY_GRID_DATA_WITHOUT_CUTTING_INWARD_ID_V2:
            return {
                ...state,
                loading: false,
                editGridData: [],
                getIDPayload: {
                    CUD: []
                }
            };

        case FETCH_DETAIL_DC_NO_SUCCESS:
            return {
                ...state,
                loading: false,
                dcNoForDetail: updatePayload
            }
        case UPDATE_CUTTING_DC_INWARD_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                cuttingDcInwardDetailsForm: {
                    fldItemRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0
                }
            };
        case FETCH_SINGLE_CUTTING_DC_INWARD_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                cuttingDcInwardDetailsForm: updatePayload
            };
        case DELETE_CUTTING_DC_INWARD_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                cuttingDcInwardDetailsForm: {
                    fldItemRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0
                }
            };
        case FETCH_CUTTING_INWARD_DETAILS_PART_COM_SUCCESS: {
            return {
                ...state,
                partComponent: updatePayload
            }
        }
        case FETCH_CUTTING_INWARD_DETAILS_UNIQUE_ID_SUCCESS: {
            return {
                ...state,
                unquieIdData: updatePayload
            }
        }
        case RESET_CUTTING_DC_INWARD_DETAILS_INFO:
            return {
                ...state,
                cuttingDcInwardDetailsForm: {
                    fldItemRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0
                }
            };
        case CREATE_CUTTING_DC_INWARD_DETAILS_FORM:
        case UPDATE_CUTTING_DC_INWARD_DETAILS_FORM:
            return {
                ...state,
                loading: false,
                cuttingDcInwardDetailsForm: {
                    ...state.cuttingDcInwardDetailsForm,
                    [payload.key]: payload.value
                }
            };
        case FETCH_CUTTING_DC_INWARD_DETAILS_FAILURE:
        case CREATE_CUTTING_DC_INWARD_DETAILS_FAILURE:
        case FETCH_CUTTING_INWARD_DETAILS_EDIT_QTY_FAILURE:
        case UPDATE_CUTTING_DC_INWARD_DETAILS_FAILURE:
        case FETCH_SINGLE_CUTTING_DC_INWARD_DETAILS_FAILURE:
        case DELETE_CUTTING_DC_INWARD_DETAILS_FAILURE:
        case FETCH_CUTTING_INWARD_DETAILS_ID_FALIURE:
        case FETCH_CUTTING_INWARD_DETAILS_PART_COM_FALIURE:
        case FETCH_CUTTING_INWARD_DETAILS_UNIQUE_ID_FALIURE:
        case FETCH_POST_BUNDLE_POST_FALIURE:
        case FETCH_BUNDLE_INPUT_FALIURE:
        case FETCH_CUTTING_DC_INWARD_BUNDLE_PROGRAM_WISE_FAILURE:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
};
